export default __webpack_public_path__ + "static/media/installer-step1.77850d8f.jpg";